import React from 'react'
import classNames from 'classnames'
import styles from './EmptyState.module.scss'

// Small decorative previews of what the empty list will hold
const illustrations = {
  cards: (
    <div className={styles.stack}>
      <div className={styles.stack_back} />
      <div className={classNames(styles.stack_front, styles.card)}>
        <span />
        <span />
        <span />
      </div>
    </div>
  ),
  slides: (
    <div className={styles.stack}>
      <div className={styles.stack_back} />
      <div className={classNames(styles.stack_front, styles.slide)}>
        <span className={styles.slide_title} />
        <div className={styles.slide_bars}>
          <i />
          <i />
          <i />
        </div>
      </div>
    </div>
  ),
  questions: (
    <div className={styles.stack}>
      <div className={styles.stack_back} />
      <div className={classNames(styles.stack_front, styles.quiz)}>
        <span className={styles.quiz_question} />
        <span className={styles.quiz_option} />
        <span className={classNames(styles.quiz_option, styles.quiz_correct)} />
      </div>
    </div>
  ),
}

function EmptyState({ variant = 'cards', title, description, action }) {
  return (
    <div className={styles.EmptyState}>
      <div className={styles.illustration} aria-hidden="true">
        {illustrations[variant]}
      </div>
      <div className={styles.body}>
        <h3 className={styles.title}>{title}</h3>
        {description && <p className={styles.description}>{description}</p>}
        {action && <div className={styles.action}>{action}</div>}
      </div>
    </div>
  )
}

export default EmptyState
